export { StructuredFeeGroup } from './StructuredFeeGroup';
